import React from 'react';
import { Input, Button, PaperClip, Select, Pagination } from 'components';
import { ServiceService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { CleanIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
}

const INITIAL_STATE = {
	search: ''
}

class ModalServices extends React.Component<Props> {

	timer: any = undefined;

	state = {
		data: [],
		page: 1,
		last_page: 1,
		form: INITIAL_STATE
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ServiceService.doctor.getServices({
			withoutLoading,
			page: this.state.page,
			...this.state.form
		});
		this.setState({
			data: res.services.rows,
			last_page: res.services.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-list-services">
				<div className="container-data">
					<div className="container-input">
						<Input
							value={ this.state.form.search }
							name="search"
							label="Buscar por nombre"
							placeholder="Buscar"
							className="input-table"
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}
					</div>

					<div className="overflow-table">
						<table>
							<thead>
								<tr>
									<th>ID</th>
									<th>Servicio</th>
								</tr>
							</thead>
							<tbody>
								{
									this.state.data.map((item: any) => {
										return (
											<tr>
												<td>{ item.id }</td>
												<td>{ item.name }</td>
											</tr>
										)
									})
								}
								{
									this.state.data.length == 0 && (
										<tr>
											<td className="no-data" colSpan={ 3 }>No se han encontrado servicios</td>
										</tr>
									)
								}
							</tbody>
						</table>
					</div>

					<Pagination 
						pages={ this.state.last_page } 
						active={ this.state.page }
						onChange={ async (page: number) => {
							await this.setState({
								page: page
							});
							this.load();
						} } />
				</div>
				<div className="row row-buttons">
					<div className="col-md-12 text-center">
						<Button type="button" className="btn-close" onClick={ () => this.props.onClose() }>
							Cerrar
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalServices;